import { createApp } from 'vue';
import { createPinia } from 'pinia';
import Router from 'vue-router';
import store from './store/store.js';
import main from './main.vue';
const pinia = createPinia();

//TODO: remove router
const routes = [
    { path: '/', name: "main" }
];

const app = createApp(main).use(pinia).mount("#js-content");

//Truncating text
require("../../components/shave.js");

// General block
import { initGeneralBlock } from "../../blocks/generalblock.js";
initGeneralBlock();

$(() => {
    loadYoutube();
    openDropdown();
});

export function openDropdown() {
    
    let contenttabs = document.getElementById('content-tabs');
    let dropdown = document.getElementById('mobileDropdown');
    let arrow = document.getElementById('dropdownArrow');
    
    //Mobilemenu dropdown
    dropdown.addEventListener('click', function() {
        // console.log('event');
        contenttabs.classList.toggle('contentActive');
        if (arrow.className === 'icon-arrow-new-up') {
            arrow.classList.remove('icon-arrow-new-up');
            arrow.classList.add('icon-arrow-new-down');
            
        }
        else if (arrow.className === 'icon-arrow-new-down') {
            arrow.classList.remove('icon-arrow-new-down');
            arrow.classList.add('icon-arrow-new-up');
        }
        
        
    })
    
}

function loadYoutube() {
    // Load the IFrame Player API code asynchronously.
    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/player_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    // Replace the 'ytplayer' element with an <iframe> and
    // YouTube player after the API code downloads.
    var player;
    var apiHasLoaded = false;
    window.onYouTubePlayerAPIReady = function () {
        apiHasLoaded = true;
        var youtubeplayers = document.querySelectorAll('.video-container div');
        for (var i = 0; i < youtubeplayers.length; i++) {

            var jsonvideo = youtubeplayers[i].dataset.video;
            var parsedjsonvideo = JSON.parse(jsonvideo);
            player = new YT.Player(
                parsedjsonvideo["videoid"],
                {
                    height: '0',
                    width: '0',
                    videoId: parsedjsonvideo["videoid"],
                    playerVars: {
                        'autoplay': parsedjsonvideo["autoplay"],
                        'controls': parsedjsonvideo["showcontrols"],
                        'fs': parsedjsonvideo["showfullscreenoption"],
                        'loop': parsedjsonvideo["loop"],
                        'modestbranding': parsedjsonvideo["modestbranding"],
                        'rel': parsedjsonvideo["showrelatedcontent"],
                        'playlist': parsedjsonvideo["videoid"],
                        'mute': parsedjsonvideo["mute"]
                    },
                    events: {
                        'onReady': function (event) {
                            if (JSON.parse(event.target.getIframe().dataset.video).mute === 1) {
                                event.target.mute();
                            }
                        }
                    }
                });
        }
    }
    if (!apiHasLoaded) {
        window.onYouTubePlayerAPIReady();
    }
}